/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Document } from './Document'
import {
  DocumentFromJSON,
  DocumentFromJSONTyped,
  DocumentToJSON,
} from './Document'

/**
 *
 * @export
 * @interface GetDocuments200Response
 */
export interface GetDocuments200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetDocuments200Response
   */
  status: boolean
  /**
   *
   * @type {Array<Document>}
   * @memberof GetDocuments200Response
   */
  data: Array<Document>
}

/**
 * Check if a given object implements the GetDocuments200Response interface.
 */
export function instanceOfGetDocuments200Response(
  value: object
): value is GetDocuments200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetDocuments200ResponseFromJSON(
  json: any
): GetDocuments200Response {
  return GetDocuments200ResponseFromJSONTyped(json, false)
}

export function GetDocuments200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocuments200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(DocumentFromJSON),
  }
}

export function GetDocuments200ResponseToJSON(
  value?: GetDocuments200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(DocumentToJSON),
  }
}
